import { QuickActionsConstants } from '../store/quickActions.constants'
import { takeLatest } from '@redux-saga/core/effects'
import { put, select } from 'redux-saga/effects'
import { getQuickActionsSelector } from '../selectors/quickActions.selector'
import { getUserIdSelector } from '../../user/selectors'
import {
  setAssessedBy,
  setAttempts,
  setBabyPod,
  setDateTime,
  setEnvironmentalControls,
  setHearingPrecautions,
  setJointCommissionTimeOut,
  setPatientLoadedCold,
  setPatientLoadedHot,
  setPatientMonitoring,
  setPatientOffloadCold,
  setPatientOffloadHot,
  setPatientPersonalProtectiveEquipment,
  setPediMate,
  setPediatricSafetyRestraintDevice,
  setPediatricStretcherChair,
  setSafetyBrief,
  setSafetyRestraints,
  setSeizurePrecautions,
  setStretcherChairMovingTo,
  setSuccessfulAttempt,
} from '../../procedures/operations/store/operations.actions'
import { setAddOperationsToTimeline } from '../store/quickActions.actions'
import { getVitalOptionsSelector } from '../../options/selectors'
import { IVitalOptionsState } from '../../options/store/options.types'

export function* setOperationsQuickAction() {
  const userId = yield select(getUserIdSelector)
  const quickActionsObject = yield select(getQuickActionsSelector)
  const { selectedQuickActionButton } = quickActionsObject
  const { props } = selectedQuickActionButton
  const { savedTimeString, currentDate, procedureAction } = props
  const vitalsOptionsState: IVitalOptionsState = yield select(getVitalOptionsSelector)
  const { assessedByOptions } = vitalsOptionsState
  const assessedByOption = assessedByOptions.find((option) => option.id === +userId)

  if (procedureAction === 'BabyPod') yield put(setBabyPod(true))
  else if (procedureAction === 'Environmental') yield put(setEnvironmentalControls(true))
  else if (procedureAction === 'HearingPrecautions') yield put(setHearingPrecautions(true))
  else if (procedureAction === 'TimeOut') yield put(setJointCommissionTimeOut(true))
  else if (procedureAction === 'LoadedCold') yield put(setPatientLoadedCold(true))
  else if (procedureAction === 'LoadHot') yield put(setPatientLoadedHot(true))
  else if (procedureAction === 'OffloadCold') yield put(setPatientOffloadCold(true))
  else if (procedureAction === 'OffloadHot') yield put(setPatientOffloadHot(true))
  else if (procedureAction === 'PatientMonitoring') yield put(setPatientMonitoring(true))
  else if (procedureAction === 'PatientPPE') yield put(setPatientPersonalProtectiveEquipment(true))
  else if (procedureAction === 'PediMate') yield put(setPediMate(true))
  else if (procedureAction === 'Pediatric Safety Restraint Device') yield put(setPediatricSafetyRestraintDevice(true))
  else if (procedureAction === 'PediStretcher') yield put(setPediatricStretcherChair(true))
  else if (procedureAction === 'SafetyBrief') yield put(setSafetyBrief(true))
  else if (procedureAction === 'SafetyRestraints') yield put(setSafetyRestraints(true))
  else if (procedureAction === 'SeizurePrecautions') yield put(setSeizurePrecautions(true))
  else if (procedureAction === 'Stretcher') yield put(setStretcherChairMovingTo(true))

  yield put(setDateTime(savedTimeString, currentDate))
  yield put(setAssessedBy(assessedByOption ? assessedByOption : null))
  yield put(setSuccessfulAttempt(true))
  yield put(setAttempts('1'))
  yield put(setAddOperationsToTimeline(true))
}

export function* setOperationsQuickActionSaga() {
  yield takeLatest([QuickActionsConstants.SET_IS_OPERATIONS_BUTTON_TYPE], setOperationsQuickAction)
}
